import { FormControlLabel, Grid, Radio, RadioGroup, TextField } from '@material-ui/core'
import React from 'react'
import FlexView from 'react-flexview/lib'
import { Controller } from 'react-hook-form'
import { StandaloneDiscountTag } from '../StandaloneDiscountTag'

export const ControlledRadioButtons = ({ name, control, defaultValue, buttons = [] }) => {
  return (
    <Controller
      rules={{ required: true }}
      as={
        <div>
          <RadioGroup InputLabelProps={{ className: 'poppins-regular' }} defaultValue={defaultValue} row>
            {buttons.map(btn => (
              <FormControlLabel
                key={btn.value}
                classes={{ label: 'poppins-regular' }}
                className={btn.className}
                control={<Radio color="primary" />}
                value={btn.value}
                label={btn.label}
              />
            ))}
          </RadioGroup>
        </div>
      }
      name={name}
      control={control}
    />
  )
}

export const LabeledRadioButton = ({
  register,
  label,
  name,
  control,
  defaultValue,
  errors,
  watch,
  buttons,
  explainForYes = false,
  tooltip = null,
  discount = false,
  shouldFlex = false,
}) => {
  const radioWatch = watch(name)
  if (discount && buttons && buttons.length > 0) {
    buttons[buttons.length - 1].className = 'yes-no-discount'
  }

  const flexProp = {
    container: shouldFlex,
    justifyContent: shouldFlex ? 'flex-end' : null,
  }

  return (
    <div className="margin-top-small">
      <Grid container spacing={1} alignItems={'center'}>
        <Grid item xs={12} sm={6}>
          <FlexView vAlignContent={'center'}>
            <div className="text-body black">{label}</div>
            {!!tooltip && tooltip}
          </FlexView>

          {errors[name] && <div className="text-small red">Required</div>}
        </Grid>
        <Grid {...flexProp} item xs={12} sm={6}>
          <FlexView vAlignContent={'center'}>
            <ControlledRadioButtons defaultValue={defaultValue} errors={errors} control={control} name={name} buttons={buttons} />
            {discount && (
              <div className="margin-left-negative avenir-book">
                <StandaloneDiscountTag />
              </div>
            )}
          </FlexView>
        </Grid>
      </Grid>
      <Grid container alignItems={'center'}>
        <Grid item xs={12}>
          {explainForYes && radioWatch == 'yes' && (
            <TextField
              fullWidth
              inputRef={register({ required: true })}
              variant="outlined"
              className="margin-bottom-basic avenir-book"
              label="Please provide more details"
              name={`${name}_details`}
              helperText={!!errors[`${name}_details`] && 'Required'}
              error={!!errors[`${name}_details`]}
            />
          )}
        </Grid>
      </Grid>
    </div>
  )
}

export const UncontrolledYeNoButton = ({ value, name, label, onChange, errors = {} }) => {
  return (
    <Grid container spacing={3} alignItems={'center'}>
      <Grid item xs={8}>
        <div className="text-body black">{label}</div>
        {errors[name] && <div className="text-body red">Required</div>}
      </Grid>
      <Grid item xs={4}>
        <RadioGroup onChange={e => onChange(name, e.target.value)} value={value}>
          <div>
            <FormControlLabel
              InputLabelProps={{ className: 'avenir-book' }}
              label={'Yes'}
              value={'yes'}
              control={<Radio color="primary" />}
            />
            <FormControlLabel
              InputLabelProps={{ className: 'avenir-book' }}
              label={'No'}
              value={'no'}
              control={<Radio color="primary" />}
            />
          </div>
        </RadioGroup>
      </Grid>
    </Grid>
  )
}

export const YesNoRadioButton = ({
  register,
  label,
  name,
  control,
  defaultValue,
  errors,
  watch,
  tooltip = undefined,
  explainForYes = false,
  discount = false,
  shouldFlex = false,
}) => {
  const radioWatch = watch(name)

  return (
    <LabeledRadioButton
      tooltip={tooltip}
      register={register}
      shouldFlex={shouldFlex}
      label={label}
      name={name}
      discount={discount}
      shouldFlex={shouldFlex}
      control={control}
      defaultValue={defaultValue}
      errors={errors}
      watch={watch}
      explainForYes={explainForYes}
      buttons={[
        { label: 'No', value: 'no' },
        { label: 'Yes', value: 'yes' },
      ]}
    />
  )
}
